import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-left', 'ArrowLeft', [["path",{"d":"M5 12l14 0"}],["path",{"d":"M5 12l6 6"}],["path",{"d":"M5 12l6 -6"}]]);